import { TableCell, Box, Button, Dialog, DialogTitle, IconButton, DialogContent, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

export const DescriptionCell = ({ description }) => {
  const [open, setOpen] = useState(false);
  const TRUNCATION_LIMIT = 180;
  // Stop event propagation and open the modal
  const handleOpen = (e) => {
    // Prevent the click from triggering any potential parent handlers 
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    setOpen(true);
  };
  
  const handleClose = () => setOpen(false);

  // Determine if the description should be truncated
  const isTruncated = description.length > TRUNCATION_LIMIT;
  
  // Prepare the text to display in the cell
  const displayText = isTruncated
    ? description.substring(0, TRUNCATION_LIMIT).trim()
    : description;

  return (
    <TableCell
      component="div"
      sx={{
        width: '50%', 
        padding: '16px 24px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
      }}
    >
      <Box
        component="span"
        sx={{
          whiteSpace: 'pre-wrap', 
          display: 'block',
          fontSize: '0.875rem' 
        }}
      >
        {displayText}
        {isTruncated && '...'}
        
        {isTruncated && (
          <Button
            variant="text"
            size="small"
            onClick={handleOpen}
            sx={{
              p: 0,
              minWidth: 0,
              ml: 1,
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '0.875rem'
            }}
          >
            Show More
          </Button>
        )}
      </Box>

      <Dialog
        
        onClose={handleClose} 
        open={open}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px',
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold', fontSize: '1.25rem', borderBottom: '1px solid #eee' }}>
          Agent Description Full View
          <IconButton
            aria-label="close"
            onClick={handleClose} 
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <Typography variant="body1" component="pre" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
            {description}
          </Typography>
        </DialogContent>
      </Dialog>
    </TableCell>
  );
};
